import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import { Form } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { formatMontant } from 'utils/numberToWordsFr';
import { toastApiErrors } from 'utils/toastApiError';
import { useEnvoyerFactureMutation } from 'actions/facturation/mutations';
import 'utils/ConfirmationModal.css';
import './facturation.css';

if (typeof window !== 'undefined') {
  Modal.setAppElement('#root');
}

const TYPE_LABELS = { facture: 'Facture', devis: 'Devis', avoir: 'Avoir' };

export default function EnvoyerFactureModal({ facture, show, onHide, onSuccess }) {
  const [envoyerFacture, { isLoading }] = useEnvoyerFactureMutation();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [destinataire, setDestinataire] = useState('');
  const [sujet, setSujet] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (facture) {
      const typeLabel = TYPE_LABELS[facture.type] || 'Document';
      const societe = facture.dossier_legal?.raison_sociale || '';
      const montant = `${formatMontant(facture.net_a_payer)} FCFA`;
      setDestinataire(facture.client_email || '');
      setSujet(`${typeLabel} ${facture.numero} - ${societe}`);
      setMessage(
        `Bonjour ${facture.client_nom_complet || facture.client_nom || ''},\n\n` +
        `Veuillez trouver ci-joint ${typeLabel.toLowerCase()} ${facture.numero} de ${societe}.\n` +
        `Montant : ${montant}\n\n` +
        `Cordialement,\n${societe}`
      );
    }
  }, [facture]);

  const submit = async (e) => {
    e.preventDefault();
    if (isSubmitting || isLoading) return;
    setIsSubmitting(true);
    try {
      const res = await envoyerFacture({
        id: facture.id,
        email: destinataire,
        sujet,
        message,
      }).unwrap();
      toast.success(`Envoyé à ${res.email_sent_to}`);
      onHide();
      if (onSuccess) onSuccess();
    } catch (err) {
      toastApiErrors(err);
    } finally {
      setIsSubmitting(false);
    }
  };

  const typeLabel = TYPE_LABELS[facture?.type] || 'Document';

  return (
    <Modal
      isOpen={show}
      onRequestClose={onHide}
      contentLabel="Envoyer par email"
      className="Modal pay-modal"
      overlayClassName="Overlay"
    >
      <h2>Envoyer {facture?.numero} par email</h2>
      <Form onSubmit={submit}>
        <Form.Group className="mb-3">
          <Form.Label>Destinataire</Form.Label>
          <Form.Control
            type="email"
            required
            value={destinataire}
            onChange={(e) => setDestinataire(e.target.value)}
            className="rounded rounded-pill"
            placeholder="email@client.sn"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Objet</Form.Label>
          <Form.Control
            type="text"
            required
            value={sujet}
            onChange={(e) => setSujet(e.target.value)}
            className="rounded rounded-pill"
          />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Message</Form.Label>
          <Form.Control
            as="textarea"
            rows={7}
            required
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="fact-no-scrollbar"
          />
        </Form.Group>
        <div className="fact-pay-info">
          Le {typeLabel.toLowerCase()} {facture?.numero} sera joint en PDF.
          {facture?.statut === 'Brouillon' && (
            <>
              {' '}L&apos;envoi émettra automatiquement le document
              {facture?.type === 'facture' ? ' (créance + écritures comptables)' : ''}.
            </>
          )}
        </div>
        <div className="pay-modal-actions">
          <button type="button" onClick={onHide} className="btn btn-danger" disabled={isLoading}>
            Annuler
          </button>
          <button
            type="submit"
            className="btn btn-primary d-inline-flex align-items-center"
            style={{ backgroundColor: '#068f7a', borderColor: '#068f7a' }}
            disabled={isLoading || isSubmitting}
          >
            {(isLoading || isSubmitting) && (
              <span
                className="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              />
            )}
            {isLoading || isSubmitting ? 'Envoi…' : 'Envoyer'}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
